import React from "react";
import './search-form-bg.scss';
import { Input, Button } from '@ui-kit';
const SearchIcon = "/images/icons/search-gray500.svg";
const ResetIcon = "/images/icons/x-gray500.svg";

const SearchFormBg = (props) => {
    const {
        onSubmit, 
        onChange, 
        value = '', 
        placeholder = '', 
        className = '', 
        ...options
    } = props;
    const classes = ['search__container_withbg', ...className.split(' ')];

    const resetSearch = (event) => {
        onChange(event);
        onSubmit(event);
        event.preventDefault();
    }

    return (
        <form onSubmit={onSubmit} className={classes.join(' ')}>
            <Input 
                type="text"
                placeholder={placeholder}
                name="search"
                value= {value}
                iconLeft={SearchIcon}
                onChange={onChange}
                spellCheck="false"
                {...options}
            />
            {value && (
                <Button 
                    type="button"
                    size="xxl"
                    theme="link-color"
                    iconLeft={ResetIcon}
                    onClick={resetSearch}
                />
            )}
        </form>
    );
}

export default SearchFormBg;